import React from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "../../components/common";
import { IdleHistorySection } from "../../components/IdleHistory";
import { useRoleModules } from "../../lib/roleModules";

export default function IdleReport() {
  const { code } = useParams();
  const access = useRoleModules(code);   // Phase 152: "tracking.idle_report" View only hides the Excel export
  return (
    <div>
      <PageHeader title="Idle History Report"
        subtitle="Review day-wise idle patterns of field staff — computed from the GPS trail" />
      <IdleHistorySection code={code} canExport={access.canWrite("tracking", "idle_report")} />
    </div>
  );
}
